export default import.meta.ROLLUP_FILE_URL_moxMPzt2SkBPQ20CK_dFDg;